import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useStore} from "../../../hooks/useStore";

const PoolSlotRateFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{"Slot Seçim Oranı"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="slotRate"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="slot_rate_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option data-testid="slot_rate_option" value={"above50"}>
                    %50 Üzeri
                </SelectField.Option>
                <SelectField.Option data-testid="slot_rate_option" value={"below50"}>
                    %50 Altı
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default PoolSlotRateFilter;
